import { render, staticRenderFns } from "./customer-transaction.vue?vue&type=template&id=b7f5745a&"
import script from "./customer-transaction.vue?vue&type=script&lang=js&"
export * from "./customer-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports